<template>
<div id="page_consulta_tigie" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Fracciones Arancelarias" class="elevation-1 px-5 py-3" >
                    <v-card-text>
                        <v-form ref="form" lazy-validation>
                            <v-row>
                                <v-col cols="3" >
                                    <v-text-field clearable clear-icon="mdi-close-circle-outline" label="Número de Fracción" type="text" @keydown.enter.prevent="buscar()" v-model="search" :rules="[rules.required]" maxlength="10" ></v-text-field>
                                </v-col>
                                <v-col cols="6" style="margin-top:20px;" >
                                    <v-btn color="primary" small @click.native="buscar" >
                                        <v-icon>search</v-icon>Buscar
                                    </v-btn>
                                    <v-btn v-if="mostrar_todas" small @click.native="cargaSecciones" >
                                        Mostrar Todas
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-spacer></v-spacer>

                        <v-row class="pa-1 primary" justify="space-between" >
                            <v-col cols="6" style=" height:500px;  overflow-y:scroll; background-color: white;" >
                                <v-treeview :active.sync="active" :items="items" :load-children="getChildrens" :open.sync="open" activatable color="info" open-on-click :open_all="true" transition>
                                    <template v-slot:prepend="{ item}" >
                                        <v-icon :id="item.id" v-if="!item.children" >insert_drive_file</v-icon>
                                    </template>
                                </v-treeview>
                            </v-col>

                            <v-divider vertical></v-divider>

                            <v-col class="d-flex text-center" style="max-height:500px; overflow-y:scroll;  background-color: white;" >

                                <div v-if="!selected" class="title text--lighten-1 font-weight-light" >
                                    <h5>Selecciona una fracción</h5>
                                </div>
                                <v-card v-else :key="selected.id" >
                                    <p id="btnPDF" style="float: right;" >
                                        <v-btn small outlined color="primary" @click="generaPDF( selected.fraccion)" title="Exportar a PDF" >
                                            <v-icon>print</v-icon>
                                        </v-btn>
                                    </p>
                                    <div id="detalleFraccion" style="height:auto;" >
                                        <div class="well" style="letter-spacing: 0.05em !important;" >
                                            <!-- TIGIE -->
                                            <div class="panel-heading" >
                                                <br />
                                                <b>TIGIE</b>
                                            </div>
                                            <div class="panel-body" >
                                                <table class="table table-bordered table-striped table-condensed" >
                                                    <tbody>
                                                        <tr>
                                                            <td><b>Sección</b></td>
                                                            <td>{{selected.seccion}}</td>
                                                            <td>{{selected.seccion_nombre}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Capítulo</b></td>
                                                            <td>{{selected.capitulo}}</td>
                                                            <td>{{selected.capitulo_nombre}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Partida</b></td>
                                                            <td>{{selected.partida}}</td>
                                                            <td>{{selected.partida_nombre}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Subpartida</b></td>
                                                            <td>{{selected.subpartida}}</td>
                                                            <td>{{selected.subpartida_nombre}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Fracción</b></td>
                                                            <td>{{selected.fraccion}}</td>
                                                            <td>{{selected.fraccion_nombre}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                                <table class="table table-bordered table-striped table-condensed" >
                                                    <thead>
                                                        <tr>
                                                            <td><b>Unidad de Medida</b></td>
                                                            <td><b>IMP</b></td>
                                                            <td><b>EXP</b></td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>{{selected.unidad_medida}}</td>
                                                            <td>{{selected.imp}}</td>
                                                            <td>{{selected.exp}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <!-- ATRIBUTOS -->
                                        <div class="well" v-if="selected.atributos.length>0" style="letter-spacing: 0.05em !important;" >
                                            <div class="panel-heading" >
                                                <br />
                                                <b>Criterios Diversos</b>
                                            </div>
                                            <div class="panel-body" >
                                                <table class="table table-bordered table-striped table-condensed" >
                                                    <tbody>
                                                        <tr>
                                                            <td colspan=3 style="background-color: #e0e2e5;" >
                                                                <span style="text-align:left;" ><b>{{selected.atributos[0].Acronimo}}</b></span>
                                                                <span style="text-align:right;float:right;" >{{selected.atributos[0].Referencia}}</span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan=3>
                                                                <span>{{selected.atributos[0].Nombre}}</span><br />
                                                                <span style="font-style:italic;" >{{selected.atributos[0].Descripcion}}</span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>{{selected.atributos[0].des_columna_1}}</b></td>
                                                            <td><b>{{selected.atributos[0].des_columna_2}}</b></td>
                                                            <td><b>{{selected.atributos[0].des_columna_3}}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <td>{{selected.atributos[0].valor1}}</td>
                                                            <td>{{selected.atributos[0].valor2}}</td>
                                                            <td>{{selected.atributos[0].valor3}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan=3>
                                                                <span style="font-size:9px;" >Sitio de consulta: {{selected.atributos[0].Site}}</span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan=3>
                                                                &nbsp;
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <!-- PLAZO RETORNO -->
                                        <div class="well" v-if="selected.plazo_retorno.length>0" style="letter-spacing: 0.05em !important;" >
                                            <div class="panel-heading" >
                                                <br />
                                                <b>Plazo de Retorno</b>
                                            </div>
                                            <div class="panel-body" >
                                                <table class="table table-bordered table-striped table-condensed" >
                                                    <tbody>
                                                        <tr>
                                                            <td><b>Fundamento Legal</b></td>
                                                            <td><b>Certificación</b></td>
                                                            <td><b>Meses</b></td>
                                                        </tr>
                                                        <tr>
                                                            <td>{{selected.plazo_retorno[0].Fundamento}}</td>
                                                            <td>{{selected.plazo_retorno[0].Certificacion}}</td>
                                                            <td>{{selected.plazo_retorno[0].meses}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                    </div>

                                </v-card>

                            </v-col>
                        </v-row>

                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import html2pdf from "html2pdf.js";

export default {
    created: function () {
        //this.cliente = this.$local_storage.get("id_cliente");
        this.cargaSecciones();
        this.test();
    },
    data() {
        return {
            active: [],
            avatar: null,
            open: [],
            open_all: false,
            users: [],
            items: [],
            tigie: "",
            fracciones: [],
            ws_fracciones: [],
            mostrar_todas: false,

            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Fracciones Arancelarias",
                    disabled: true,
                    href: ""
                }
            ],

            rules: {
                required: v => !!v || "Este campo es requerido",
            },
            search: "",

        };
    },

    computed: {
        selected() {
            if (!this.active.length) return undefined

            const id = this.active[0]

            return this.fracciones.find(fraccion => fraccion.id === id)
        },
    },

    methods: {
        async getChildrens(item) {
            let datos = {
                id: item.id,
                tipo: item.tipo,
            }
            await axios.post(this.$hostname + "catalogos/fracciones/get_childrens/", datos)
                .then(response => {
                    item.children = response.data;
                    if (item.tipo == "subpartida") {
                        this.fracciones = response.data;
                    }
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "No fue posible obtener los datos. Favor de comunicarse con soporte.",
                        footer: ""
                    });
                    console.log(error);
                });

        },
        test() {
            let datos = {
                cmd:'fracciondetails',
                u:'lourdes.aguilar@econnect.mx',
                p:'12345678',
                f:'60053299',
                headers: {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                }
            }
            /*
            una
            https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=fracciondetails&u=lourdes.aguilar@econnect.mx&p=12345678&f=60053299
            lista
            https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=fracciondetailsbyrange&u=lourdes.aguilar@econnect.mx&p=12345678&rangetype=list&f=60053299,%2060053299
           
            axios.get("https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=fracciondetails&u=lourdes.aguilar@econnect.mx&p=12345678&f=01029003" )
                .then(response => {
                    this.tigie = response.data;
                    console.log(this.tigie);
                })
                .catch(error => {
                    
                    console.log(error);
                });
 */
                fetch('https://hts.gsmartcode.com/DesktopModules/IWebCSharp/webservice.asmx/GetTableDataJSON?cmd=fracciondetailsbyrange&u=lourdes.aguilar@econnect.mx&p=12345678&rangetype=list&f=60053299,%2060053299')
                    .then(response => response.text())
                    .then(data => {
                       console.log(data);
                       var  parser = new DOMParser();
                       var  xmlDoc = parser.parseFromString(data,"text/xml");
                       let x = xmlDoc.getElementsByTagName("string")[0].childNodes[0].nodeValue;
                       var obj = JSON.parse(x);
                       this.ws_fracciones = obj;
                    });

        },    
        buscar: function () {
            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                this.items = [];
                this.fracciones = [];
                let datos = {
                    clave: this.search
                }
                axios.post(this.$hostname + "catalogos/fracciones/get_fraccion/", datos)
                    .then(response => {
                        this.items = response.data.arbol;
                        this.fracciones = response.data.fracciones;
                        this.mostrar_todas = true;

                        var thisObj = this;
                        for (var k in this.fracciones) {
                            var nombre = this.fracciones[k].seccion + " - " + this.fracciones[k].seccion_nombre;
                            setTimeout(function () {
                                thisObj.expandirNodo(nombre);
                            }, 300);
                            var capitulo = this.fracciones[k].capitulo + " - " + this.fracciones[k].capitulo_nombre;
                            setTimeout(function () {
                                thisObj.expandirNodo(capitulo);
                            }, 300);
                            var partida = this.fracciones[k].partida + " - " + this.fracciones[k].partida_nombre;
                            setTimeout(function () {
                                thisObj.expandirNodo(partida);
                            }, 300);
                            var subpartida = this.fracciones[k].subpartida + " - " + this.fracciones[k].subpartida_nombre;
                            setTimeout(function () {
                                thisObj.expandirNodo(subpartida);
                            }, 300);
                            setTimeout(function () {
                                thisObj.expandirNodo(thisObj.fracciones[k].name);
                            }, 300);
                        }

                    })
                    .catch(error => {
                        this.$swal({
                            type: "warning",
                            title: "Fracción no encontrada",
                            text: "Favor de verificar.",
                            footer: ""
                        });
                        this.mostrar_todas = true;
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                    });
            }

        },
        expandirNodo: function (nombre) {
            try {
                for (const a of document.getElementsByClassName("v-treeview-node__root")) {
                    if (a.textContent.includes(nombre)) {
                        a.click();
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
        cargaSecciones: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.items = [];
            this.fracciones = [];
            this.search = "";
            axios.post(this.$hostname + "catalogos/fracciones/get_secciones/")
                .then(response => {
                    this.items = response.data;
                })
                .catch(error => {
                    console.log(error);
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "No fue posible obtener las secciones de las fracciones.",
                        footer: ""
                    });
                }).then(() => {
                    this.mostrar_todas = false;
                    this.$root.$dialogLoader.hide();
                });
        },
        generaPDF: function (fraccion) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let html = document.getElementById("detalleFraccion");

            var opt = {
                margin: [1, 0.5, 1, 0.5], //top, left, bottom, right
                filename: "Tigie-" + fraccion +".pdf",
                image: {
                    type: "jpeg",
                    quality: 0.5
                },
                html2canvas: {
                    scale: 2
                },
                jsPDF: {
                    unit: "in",
                    format: "letter",
                    orientation: "portrait"
                }
            };
            var thisObj = this;
            html2pdf()
                .set(opt)
                .from(html)
                .toPdf().get('pdf')
                .then(function (pdf) {
                    var totalPages = pdf.internal.getNumberOfPages();

                    for (var i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(10);
                        pdf.setTextColor(150);
                        pdf.text("Detalle de la fracción arancelaria " + fraccion, pdf.internal.pageSize.getWidth() - 3.2, .8);
                        pdf.text('_________________________________________________________________________________________________',
                            .5, .85);
                        pdf.text("" + i, pdf.internal.pageSize.getWidth() - .6, pdf.internal.pageSize.getHeight() - 1.1);
                    }
                    thisObj.$root.$dialogLoader.hide();
                })
                .save();

        }

    }
};
</script>

<style>
.v-treeview-node__label,
.v-treeview-node__children {
    font-size: 12px;
}

.well {
    font-size: 16px;
    font-family: "Helvetica Neue", Roboto, Arial, "Droid Sans", sans-serif;
    text-align: justify;
    min-height: 20px;
    padding: 19px;
    margin-bottom: 20px;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .05);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .05);
}

.panel-heading {
    background-color: #e0e2e5;
    padding-left: 5px;
    padding-right: 5px;
    min-height: 55px;
    margin-left: -19px;
    margin-right: -19px;
    margin-top: -19px;
}

.panel-body {
    background-color: white;
    padding-left: 5px;
    padding-right: 5px;
    font-size: 12px;
    margin-left: -15px;
    margin-right: -15px;
    margin-top: 10px;
}
</style>
